// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rV_bB","left":"styles_left__1IVRu"};